import "../../common/common_styles.css";
import UploadContent from "../UI/UploadContent/uploadContent";
import { selectStudentWorkData, setStudentWorkData } from '../../slices/gradingForm';
import { useState, useEffect } from "react";
import checkboxClasses from "../CriteriaSubmission/assesmentForm/questionTypes/questionTypes.module.css"
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import ErrorModal from "../UI/error_modal/error_modal";
const StudentWorkCriteria = ( ) => {

    const [suggestGrade, setSuggestGrade] = useState(false);
    const [fileUploadMessage, setFileUploadMessage] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);

    const dispatch = useDispatch();
    const storeData = useSelector(selectStudentWorkData);
    const location = useLocation();

    // Function to check and set the file upload message based on metadata
    const checkFileUploadMessage = (metadata) => {
        let message = "";
        metadata.forEach((file) => {
          // Check if OCR confidence is below a threshold (e.g., 80)
          if (file.ocr_confidence < 80) {
            message += `${file.name} - difficult to read and may need to be rescanned.\n\n`;
          }
        });
        setFileUploadMessage(message);
      };
    
      // Use effect to check and set the message when metadata changes
      useEffect(() => {
        const fileMetadata = location.state?.fileMetadata || [];
        if (fileMetadata.length > 0) {
            checkFileUploadMessage(fileMetadata);
        }
    }, [location.state?.fileMetadata]);
    
      // Directly use fileUploadMessage state to decide modal visibility
    useEffect(() => {
        if (fileUploadMessage) {
          setShowErrorModal(true);
        }
      }, [fileUploadMessage]);

    const handleSuggestionChange = (e)=>{
      dispatch(setStudentWorkData({ preliminaryGrade: e.target.value }));
    }

    return (
        <div>
          <UploadContent 
              textLabel="Paste or upload the student's work:"
              textPlaceholder="Enter content here, or upload it as a file below."
              nameInStore="studentWork"
              selectStoreData={selectStudentWorkData}
              setStoreData={setStudentWorkData}

          />
          <br />
          <br />    
         
             <div style={{width: "450px"}}>
                    <div className={checkboxClasses.individualCheckbox} >
                        <label className={checkboxClasses.container}  >
          
                            <input
                                name={"check"}
                                type="checkbox"
                                checked={suggestGrade}
                                onChange={()=>setSuggestGrade((prev)=>!prev)} 
                                />
                             <Tooltip title="Check this box only if you have a grade or grade range in mind. The AI will use your input to tailor its feedback">
                            <span className={checkboxClasses.checkmark}></span>
                            </Tooltip>  
                        </label>
                        <span>{"I'd like to suggest a grade for this student's work"}</span>
                    </div>
                </div>
      
                <div style={{width: "550px", marginLeft:"36px", marginTop:"10px", marginBottom:"10px"}}>
                    {suggestGrade ? <input onChange={handleSuggestionChange} placeholder="Enter your suggested grade or grade range (e.g., &quot;B &quot;, &quot;A/A&quot; , &quot;70-80&quot;, etc)" />
 : <></>}
                </div>
                <ErrorModal
                    isOpen={showErrorModal}
                    onClose={() => setShowErrorModal(false)}
                    titleText={"Potential issue with upload"}
                    bodyText={fileUploadMessage}
                />



        </div>
    );
};

export default StudentWorkCriteria;
